import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface ActivationModalProps {
  isVisible: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const ActivateDynamicControllerModal: React.FC<ActivationModalProps> = ({ isVisible, onOk, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('activateDynamicController')}
      open={isVisible}
      onOk={onOk}
      okText={t('activate')}
      maskClosable={false}
      destroyOnClose={true}
      onCancel={onCancel}
      centered
      width={550}
      maskTransitionName=""
      transitionName=""
    >
      <div>{t('activateDynamicControllerMessage')}</div>
    </Modal>
  );
};
